import { gql, useSubscription } from "@apollo/client";
import { readToken } from "services/localStorage.service";

const FORMATTING_DATA = gql`
  subscription textModifier(
    $token: String!
    $text: String!
    $instructions: [String]!
  ) {
    modificationGenerator(
      token: $token
      text: $text
      instructions: $instructions
    ) {
      text
      timeTaken
      error
      finished
    }
  }
`;
interface TextModifierGeneratorProps {
  instructions: any;
  text: any;
  onChange: (text: any) => void;
  onComplete: () => void;
}

const TextModifierGenerator: React.FC<TextModifierGeneratorProps> = ({
  instructions,
  text,
  onChange,
  onComplete,
}) => {
  useSubscription(FORMATTING_DATA, {
    variables: {
      token: readToken(),
      text: text,
      instructions: instructions,
    },
    onSubscriptionData: ({ subscriptionData }) => {
      onChange(subscriptionData.data.modificationGenerator.text);
    },
    onComplete: () => {
      // Handle subscription completion
      onComplete && onComplete();
    },
  });
  // You can return null or any other JSX element you want to render
  return null;
};

export default TextModifierGenerator;
